import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/lib/middleware'
import { RolesAndPermissionsPage } from '@/features/access-control/roles-and-permissions-page'

function PermissionMatrixRoute() {
  return <RolesAndPermissionsPage defaultTab='matrix' />
}

export const Route = createFileRoute(
  '/_authenticated/_organization/organizations/settings/permission-matrix'
)({
  beforeLoad: async () => {
    await requireAuth()
  },
  component: PermissionMatrixRoute,
})
